import React, { Component } from 'react';
import './App.css';
import { Grid } from '@material-ui/core';
import randomColor from 'randomcolor';
import Intro from './components/Intro/Intro';
import Conclusion from './components/Conclusion/Conclusion';
// import Sources from './components/Sources/Sources';
import MapView from './components/Map/MapView';
import Chart_Village_Person_Board from './components/Chart/Chart_Village_Person_Board';
import TextPersonSpecies from './components/MyAnalysis/TextPersonSpecies';
import Chart_Village_Species_Board from './components/Chart/Chart_Village_Species_Board';
import Chart_Village_Gender_Board from './components/Chart/Chart_Village_Gender_Board';
import Chart_Village_SpeciesGender_Board from './components/Chart/Chart_Village_SpeciesGender_Board';
import TextGenderPersonSpecies from './components/MyAnalysis/TextGenderPersonSpecies';
import TextZodiac1 from './components/MyAnalysis/TextZodiac1';
import TextZodiac2 from './components/MyAnalysis/TextZodiac2';
// import Chart_Zodiac_Board from './components/Chart/Chart_Zodiac_Board';
import Chart_Zodiac_Board1 from './components/Chart/Chart_Zodiac_Board1';
import Chart_Zodiac_Board2 from './components/Chart/Chart_Zodiac_Board2';
import Chart_Zodiac_Board3 from './components/Chart/Chart_Zodiac_Board3';
import Chart_Zodiac_Board4 from './components/Chart/Chart_Zodiac_Board4';
// import List_Villager from './components/List/List_Villager';
// import Table_Villager from './components/Table/Table_Villager';
import DataTable_Villager_Board from './components/Table/DataTable_Villager_Board';
/* #c1f2b1 #f3ffe6 */

import Chord from './components/Chart/Chord';


function App() {
  return (
    <div className="App">
    <div className="wrapper-outer">
      <Grid container spacing={3}>
        <Grid className="grid1" item xs={12} sm={12} md={12} lg={12} xl={12} style={{background:'#9cd2ff'}}> 
          <h2>Animal Crossing: Rising Popularity</h2>
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={3} xl={3} style={{background:'#c1f2b1'}}> 
          <Intro />
        </Grid>
        <Grid item xs={12} sm={6} md={8} lg={9} xl={9} style={{background:'#c1f2b1'}}> 
          <MapView />
        </Grid>

        <Grid item xs={12} sm={12} md={8} lg={6} xl={6} style={{background:'white'}}> 
          <Chart_Village_Species_Board />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3} style={{background:'white'}}> 
          <TextPersonSpecies />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3} style={{background:'white'}}> 
          <Chart_Village_Person_Board />
        </Grid>

        <Grid item xs={12} sm={12} md={8} lg={6} xl={6} style={{background:'white'}}> 
          <Chart_Village_SpeciesGender_Board />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3} style={{background:'white'}}> 
          <TextGenderPersonSpecies />
        </Grid>  
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3} style={{background:'white'}}> 
          <Chart_Village_Gender_Board />
        </Grid>

        <Grid item xs={12} sm={6} md={4} lg={3} xl={3} style={{background:'white'}}> 
          <TextZodiac1 />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3} style={{background:'white'}}> 
          <Chart_Zodiac_Board1 />
        </Grid>        
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3} style={{background:'white'}}> 
          <Chart_Zodiac_Board2 />
        </Grid>  

        <Grid item xs={12} sm={6} md={4} lg={3} xl={3} style={{background:'white'}}> 
          <TextZodiac2 />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3} style={{background:'white'}}> 
          <Chart_Zodiac_Board3 />
        </Grid>
        <Grid item xs={12} sm={6} md={4} lg={3} xl={3} style={{background:'white'}}> 
          <Chart_Zodiac_Board4 />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6} style={{background:'white'}}> 
          <DataTable_Villager_Board />
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={6} xl={6} style={{background:'white'}}> 
          <Chord />
        </Grid>

        <Grid item xs={12} sm={12} md={6} lg={3} xl={3} style={{background:'white'}}> 
          <h4>Conclusion</h4>
          <p>If you, as a player, want the most diverse Villagers as your neighbors in Animal Crossing, looking at the demographics provided by these charts can help you do an analysis of the Villagers. Or you can analyze the resources needed to acquire particular furniture by looking at how many Stones you need to build a Taurus Bathtub or Gold needed to create a Libra Scale. Below are some suggestions on how to create diverse and fun experiences in Animal Crossing.</p>
        </Grid>
        <Grid item xs={12} sm={12} md={4} lg={3} xl={3} style={{background:'white'}}> 
          <h4>Sources</h4>
            <a href="https://animalcrossing.fandom.com/" target="blank">Animal Crossing Fandom</a>
            <br />
            <a href="https://newzoo.com/insights/articles/top-100-countries-represent-99-6-81-5bn-global-games-market/" target="_blank">newzoo</a>
            <br />
            <a href="https://www.astrology-zodiac-signs.com/" target="blank">Astrology Zodiac Signs</a>             
        </Grid>

      </Grid>    
    </div>
    </div>
  );
}
 
export default App;

/* 
Best Tutorial on Fontawesome:
https://fontawesome.com/how-to-use/customizing-wordpress/snippets/setup-cdn-webfont

Chart.js 
https://blog.bitsrc.io/customizing-chart-js-in-react-2199fa81530a 

Table:
https://dev.to/vsfarooqkhan/data-tables-in-react-js-made-easy-with-mdbreact-27b9
https://mdbootstrap.com/docs/react/tables/datatables/

*/